export default function focusInputField(input) {
  if (input) {
    setTimeout(() => {
      input.focus();
    }, 100);
  }
}
